// extracted by mini-css-extract-plugin
export var section = "section-module--section--RG9F+";
export var content = "section-module--content--NHsK8";
export var hasImage = "section-module--hasImage--D1ggA";